import { createContext } from 'react'

export const ProductoContext = createContext(null);
export const DisabledContext = createContext(null);
export const IdProductoContext = createContext(null);

